var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxWaterSurface = function Svg18PxWaterSurface(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#56565C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.75 14.25a4.7 4.7 0 0 0 3.625-1.692 4.73 4.73 0 0 0 7.25 0 4.68 4.68 0 0 0 3.625 1.692M1.75 9.846a4.7 4.7 0 0 0 3.625-1.692 4.73 4.73 0 0 0 7.25 0 4.68 4.68 0 0 0 3.625 1.692M1.75 5.442A4.7 4.7 0 0 0 5.375 3.75 4.7 4.7 0 0 0 9 5.442a4.68 4.68 0 0 0 3.625-1.692 4.68 4.68 0 0 0 3.625 1.692"
  })));
};
export default Svg18PxWaterSurface;